import type { Question } from '../../types';
import { HAB_MH_CONDITION } from './shared-options';

// ---------------------------------------------------------------------------
// Documents Checklist
// Source: Centered Partners revised intake email (2026-06-11).
// Documents do most of the underwriting work — this captures what the
// prospect can provide so the team can chase the rest. Uploading the actual
// files happens via the QuickStart document path / shared folder.
// ---------------------------------------------------------------------------

export const documentsChecklistQuestions: Question[] = [
  {
    id: 'doc_priority',
    text: 'The two documents that matter most — can you provide them?',
    subtext:
      'Carriers will not provide firm quotes without current loss runs. Your current agent or carrier can produce these on request.',
    section: 'documents',
    group: 'doc_checklist',
    sort_order: 100,
    field_type: 'multiselect',
    options: [
      {
        label: 'Current (expiring) policies — all lines',
        value: 'expiring_policies',
        help: 'Full copies including endorsements.',
      },
      {
        label: '5 years of currently valued loss runs',
        value: 'loss_runs',
        help: 'By line and by carrier — paid, reserves, total incurred, claim status.',
      },
      {
        label: 'Neither yet — I need to request them',
        value: 'none_yet',
      },
    ],
    required: true,
    field_path: 'documents.priority',
    conditions: HAB_MH_CONDITION,
    tags: ['documents'],
  },
  {
    id: 'doc_helpful',
    text: 'Which of these do you have on hand?',
    subtext: 'Send them in whatever form you already keep them — no need to create anything new.',
    section: 'documents',
    group: 'doc_checklist',
    sort_order: 110,
    field_type: 'multiselect',
    options: [
      {
        label: 'Rent roll or property/unit export',
        value: 'rent_roll',
        help: 'From Yardi, RealPage, AppFolio, Rent Manager, or similar.',
      },
      { label: 'List of property addresses', value: 'address_list' },
      {
        label: 'Statement of values, appraisal, or Phase I environmental report',
        value: 'lender_docs',
        help: 'Any document a lender already required.',
      },
      {
        label: 'Experience modification worksheet + payroll summary',
        value: 'xmod_payroll',
        help: 'For workers comp.',
      },
      { label: 'Vehicle list and driver list', value: 'vehicle_driver_lists' },
      { label: 'None of these', value: 'none' },
    ],
    required: false,
    field_path: 'documents.helpful',
    conditions: HAB_MH_CONDITION,
    tags: ['documents'],
  },
];
